<template>
  <input
    ref="inputRef"
    type="text"
  >
</template>

<script>
/* eslint-disable no-trailing-spaces */
/* eslint-disable vue/require-default-prop */
import { useCurrencyInput } from 'vue-currency-input'

export const currencyInputOptions = {
  locale: 'it-IT',
  currency: 'XXX',
  currencyDisplay: 'hidden',
  hideCurrencySymbolOnFocus: true,
  hideGroupingSeparatorOnFocus: false,
  hideNegligibleDecimalDigitsOnFocus: true,
  autoDecimalDigits: false,
  exportValueAsInteger: false,
  autoSign: false,
  useGrouping: true,
}
export default {
  name: 'CurrencyInput',
  props: {
    value: Number, 
    options: Object,
  },
  setup(props) {
    const { inputRef } = useCurrencyInput(props.options ?? currencyInputOptions)
    return { inputRef }
  },
}
</script>
